/**
 * Created by forbiz on 2019-02-11.
 */

const myPage = () => {
    const $document = $(document);

    const myPageAccd = () => {
        $document
            .on('click', '.box__accd', function(e) {
                const $this = $(this);

                if ( !$this.hasClass('on') ) {
                    $this.addClass('on').text('접어두기');
                    $this.siblings('.boxInner').stop().slideDown();
                } else {
                    $this.removeClass('on').text('펼쳐보기');
                    $this.siblings('.boxInner').stop().slideUp();
                }

                e.preventDefault();
            });
    };

    const myPageBanner = () => {
        hdFn.hdSlide('.sub-cont__sec .banner', {
            fade: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            cssEase: 'linear',
            dots: true,
            infinite: true,
            speed: 300,
        });
    };

    const myPageInit = () => {
        myPageAccd();
        //myPageBanner();
    };

    myPageInit();
    window.myPageBanner = myPageBanner
};

export default myPage;